import Table from './Table';

export default Table;



// WEBPACK FOOTER //
// ./components/table/index.tsx